<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">切換使用者帳號</h3>
        </div>
        <div class="modal-body" :class="{'section-loading': sectionLoading}">
          <form class="form">
            <div class="form-group row">
              <label for="birth-year" class="col-4 text-right">帳號</label>
              <div class="col-8">
                <input type="text"
                ref='inputAccount'
                id='inputText'
                class="form-control form-control-inline "
                @keydown.enter="submit()"
                v-model="form.userID">
              </div>
            </div>

            <div class="action text-right">
              <a @click="$emit('close')" class="btn btn-default">
                取消
              </a>
              <a @click.prevent="submit()" class="btn btn-primary">
                確定
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosFormSubmit from "@/service/axiosFormSubmit.js";
import { setTimeout } from "timers";
import { mapActions } from "vuex";

export default {
  name: "bkToggleUserModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    inputs: {
      type: Object,
      default: null,
    },
  },
  watch: {
    open: function() {
      setTimeout(() => {
        this.$refs.inputAccount.focus();
      }, 100);
    },
  },
  data() {
    return {
      form: {
        userID: "",
      },
      sectionLoading: false,
    };
  },
  methods: {
    ...mapActions(["updateCustInfo"]),
    submit() {
      const url = "/servlet/HttpDispatcher/MXAuth/switchUser";
      let userID = this.form.userID.toUpperCase().trim();

      let data = {};
      data = {
        switchId: userID,
        source: "BNK",
      };
      this.sectionLoading = true;
      axiosFormSubmit(url, data, "切換帳號").then(() => {
        this.$router.push({ path: "/bkmv/allHolder" });
        location.reload();
      });
    },
  },
};
</script>
